import React from "react";

const Input = ({type, placeholder, isRequired, name}) => {
	return <input type={type} name={name} placeholder={placeholder} required={isRequired} className='w-full p-4 rounded-md bg-gray-100 focus:outline-none focus:ring-1 focus:ring-tad-primary focus:ring-opacity-50' />;
};

export default Input;
